module.exports = __webpack_public_path__ + "static/img/ui_zhongjian.8ba4ed1.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/ui_zhongjian.png
// module id = ND6e
// module chunks = 0